module.exports = __webpack_public_path__ + "img/shopping_bag.7e34e08a.svg";